import React, { FC, useState } from 'react';

type Tab = 'SEND' | 'RECEIVE' | 'BIDIRECTIONAL';

const As2SetupGuide: FC = () => {
    const [open, setOpen] = useState(false);
    const [tab, setTab] = useState<Tab>('BIDIRECTIONAL');

    const tabClass = (t: Tab) =>
        `rounded px-3 py-1 text-xs font-medium ${
            tab === t ? 'bg-[#bd902e] text-white' : 'bg-white text-slate-600 ring-1 ring-slate-200'
        }`;

    return (
        <div className="admin-motion-card rounded-md border border-slate-200 bg-slate-50 text-sm text-slate-700">
            <button
                type="button"
                className="flex w-full items-center justify-between px-3 py-2 font-medium text-slate-800 hover:bg-slate-100"
                onClick={() => setOpen((v) => !v)}
            >
                AS2 setup guide (SEND / RECEIVE / BIDIRECTIONAL)
                <span className="text-xs text-slate-500">{open ? 'Hide' : 'Show'}</span>
            </button>
            {open && (
                <div className="space-y-3 border-t border-slate-200 px-3 py-3">
                    <p className="text-xs text-slate-600">
                        Use <strong>Add partner</strong> on Integrations to onboard production AS2/EPCIS partners.
                        The wizard creates a production record plus an automatic pre-go-live test record for MDN
                        validation before you enable live sends.
                    </p>
                    <div className="flex flex-wrap gap-2">
                        <button type="button" onClick={() => setTab('SEND')} className={tabClass('SEND')}>
                            SEND
                        </button>
                        <button type="button" onClick={() => setTab('RECEIVE')} className={tabClass('RECEIVE')}>
                            RECEIVE
                        </button>
                        <button type="button" onClick={() => setTab('BIDIRECTIONAL')} className={tabClass('BIDIRECTIONAL')}>
                            BIDIRECTIONAL
                        </button>
                    </div>
                    {tab === 'SEND' && (
                        <ul className="list-inside list-disc space-y-1 text-xs">
                            <li>Required: partner AS2 ID, AS2 URL, certificate, linked pharmacy</li>
                            <li>Outbound OpenAS2 route is auto-generated (Antar → partner)</li>
                            <li>Test with Test URL and Send test EPCIS on AS2 Partners</li>
                        </ul>
                    )}
                    {tab === 'RECEIVE' && (
                        <ul className="list-inside list-disc space-y-1 text-xs">
                            <li>Required: partner AS2 ID, certificate, linked supplier</li>
                            <li>Inbound route is auto-generated (partner → Antar)</li>
                            <li>Share Antar inbound URL + AS2 ID + public cert with partner</li>
                            <li>Review inbound messages in AS2 Messages (IN + Awaiting admin review)</li>
                        </ul>
                    )}
                    {tab === 'BIDIRECTIONAL' && (
                        <ul className="list-inside list-disc space-y-1 text-xs">
                            <li>Required: all SEND and RECEIVE fields (URL, pharmacy, supplier, cert)</li>
                            <li>Both outbound and inbound OpenAS2 routes are created</li>
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
};

export default As2SetupGuide;
